import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWhoami } from '@cotera/client/app/stores/org';
import { useOpenNewTriggerModal } from './use-open-new-trigger-modal';

/** Opens the new-trigger wizard for `/triggers/new` bookmarks and links. */
export const TriggersNewPage: React.FC = () => {
  const openNewTriggerModal = useOpenNewTriggerModal();
  const navigate = useNavigate();
  const org = useWhoami((s) => s.org);
  const openedRef = useRef(false);

  useEffect(() => {
    if (openedRef.current) {
      return;
    }
    openedRef.current = true;
    openNewTriggerModal();
    navigate(`/${org.slug}/triggers`, { replace: true });
  }, [openNewTriggerModal, navigate, org.slug]);

  return null;
};
